var React = require('react');

function IcLinkOuter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.00001 6L10 5h9v9l-1 1-1 1V8.41421L6.70712 18.7071l-1.41421-1.4142L15.5858 7H8.00001l1-1z","fill":"currentColor"}));
}

IcLinkOuter.defaultProps = {"width":"24","height":"24"};

module.exports = IcLinkOuter;

IcLinkOuter.default = IcLinkOuter;
